import apiClient from './apiClient';

console.warn('API endpoints for Templates are not defined in README.md. Using placeholder functions.');

export const getTemplates = () => {
  return apiClient('/templates');
};

export const createTemplate = (templateData) => {
  return apiClient('/templates', { body: templateData, method: 'POST' });
};

export const updateTemplate = (templateId, templateData) => {
  return apiClient(`/templates/${templateId}`, { body: templateData, method: 'PUT' });
};

export const deleteTemplate = (templateId) => {
  return apiClient(`/templates/${templateId}`, { method: 'DELETE' });
}; 